import React from 'react'
import { Route, Routes } from 'react-router-dom'
import AdminExtensions from './AdminExtensions/AdminExtensions'
import UserAdministration from './AdminCognito/UserAdministration'
import { AdminSessions } from './AdminSessions/AdminSessions'
import { UserSessions } from './AdminSessions/UserSessions/UserSessions'

export const SecurityHome = () => {
  return <div>Sucurity Home</div>
}
export const Security = () => {
  return (
    <Routes>
      <Route path="/" element={<SecurityHome />} />
      <Route path="/file-extension/*" element={<AdminExtensions />} />
      <Route path="/cognito/*" element={<UserAdministration />} />
      <Route path="/user-sessions/*" element={<AdminSessions />} />
      <Route path="/user-sessions/:id/*" element={<UserSessions />} />
    </Routes>
  )
}
